import { Component } from '@angular/core';
import { Language } from '@libraries/design-system';
import { Store } from '@ngrx/store';
import {
  CloseActive,
  getPreferredLanguage,
  isSkipApplicationAllowed,
  preferredLanguageIsSpanish,
  RedirectToApplication,
  spanishDocsDisabledDisclaimer,
  spanishDocsEnabledDisclaimer,
  spanishProgramGuidelinesLink,
  SwitchPreferredLanguage,
} from '../../state';

@Component({
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss'],
  standalone: false,
})
export class SuccessComponent {
  preferredSpanish$ = this.store.select(preferredLanguageIsSpanish);
  preferredLanguage$ = this.store.select(getPreferredLanguage);
  programGuidelinesLink$ = this.store.select(spanishProgramGuidelinesLink);
  spanishDocsEnabledDisclaimer$ = this.store.select(spanishDocsEnabledDisclaimer);
  spanishDocsDisabledDisclaimer$ = this.store.select(spanishDocsDisabledDisclaimer);
  isSkipApplicationAllowed$ = this.store.select(isSkipApplicationAllowed);

  constructor(private store: Store) {}

  submit() {
    this.store.dispatch(RedirectToApplication());
  }

  close() {
    this.store.dispatch(CloseActive());
  }

  done() {
    window.location.href = 'https://www.ygrene.com/commercial';
  }

  toggleLanguage(language: Language) {
    this.store.dispatch(
      SwitchPreferredLanguage({
        preferredLanguage: language,
      })
    );
  }
}
